// extracted by mini-css-extract-plugin
module.exports = {"lazyLoadWrapper":"Lazyload_lazyLoadWrapper__efm0i","placeholderWrapper":"Lazyload_placeholderWrapper__iw3tr"};